<!-- 由 suu 创建于 2022-08-30 星期二 -->
<template>
  <div class="week-summary" v-if="info">
    <!-- 头部背景 -->
    <img
      class="sum-top-bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-top-bg"
      alt=""
    />
    <!-- <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-ibg-2?v=1"
        alt=""
        class="sum-float-bg-2"
      />
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-ibg-3?v=1"
        alt=""
        class="sum-float-bg-3"
      />-->
    <img
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-ibg-4?v=1"
      alt=""
      class="sum-float-bg-4"
    />
    <div class="logo">
      <img
        class="logo-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
      <div class="desc">打卡就能瘦</div>
    </div>
    <!-- 用户信息 -->
    <div class="sum-info">
      <div class="i-left">
        <!-- 头像 -->
        <img
          class="l-img"
          :src="
            info.userResult.head_img ||
            'https://cdnvue.gymcity.com.cn/uploads/474b47b400369d72944da3aa665924b3.png'
          "
          alt=""
        />
        <div class="l-desc">
          <div class="d-name">{{
            info.userResult.truename || info.userResult.nickname
          }}</div>
          <div class="d-title">{{ info.userResult.alias }}</div>
        </div>
      </div>
      <!-- 分享按钮 -->
      <!-- 体重 腰围同时下降 或 有饮食打卡时显示分享按钮 -->
      <img
        v-if="
          (info.comprehensiveData.fatReduction.weight_diff &&
            info.comprehensiveData.fatReduction.weight_diff < 0 &&
            info.comprehensiveData.fatReduction.waist_diff &&
            info.comprehensiveData.fatReduction.waist_diff < 0) ||
          info.comprehensiveData.clockList.dietNum
        "
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-share"
        alt=""
        class="i-right user-btn"
        @click="handleShare"
      />
    </div>
    <!-- 成就相关 -->
    <div class="sum-panel">
      <div
        class="p-achi"
        v-if="info.comprehensiveData.achievementName.cron_url"
      >
        <div class="achi-left">
          <div class="l-title"
            >本周成就
            <van-icon
              @click="handleAchi"
              class="l-icon user-btn"
              name="info-o"
            />
          </div>
          <!-- 成就名称 -->
          <img
            :src="info.comprehensiveData.achievementName.cron_url"
            alt=""
            class="l-img"
          />
        </div>
        <!-- 勋章 -->
        <!-- :src="info.achievementName.cron_url" -->
        <img
          :src="info.comprehensiveData.achievementName.medal_url"
          v-if="info.comprehensiveData.achievementName.medal_url"
          alt=""
          class="achi-right"
        />
      </div>
      <div class="p-desc">
        <div class="d-top">
          <div class="t-title">综合成绩</div>
          <div
            class="t-cent-no"
            v-if="info.comprehensiveData.clockList.physicalNum == 0"
          >
            宝贝本周未上传体测卡
          </div>
          <div class="t-cent" v-else>
            <div class="c-item">
              <div class="i-title">体重变化(斤)</div>
              <div class="i-num"
                >{{
                  info.comprehensiveData.fatReduction.weight_diff == '-'
                    ? info.comprehensiveData.fatReduction.weight_diff
                    : (
                        info.comprehensiveData.fatReduction.weight_diff * 2
                      ).toFixed(1)
                }}
                <i
                  class="iconfont icon-xingzhuangjiehebeifen"
                  v-if="info.comprehensiveData.fatReduction.weight_diff < 0"
                ></i>
              </div>
            </div>
            <div class="c-item">
              <div class="i-title">腰围变化(厘米)</div>
              <div class="i-num"
                >{{ info.comprehensiveData.fatReduction.waist_diff }}
                <i
                  class="iconfont icon-xingzhuangjiehebeifen"
                  v-if="info.comprehensiveData.fatReduction.waist_diff < 0"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 饼图 -->
        <sum-pie-chart :datum="pie" v-if="pie"></sum-pie-chart>
      </div>
    </div>
    <!-- 营养师 -->
    <div class="sum-panel sum-panel-yys" v-if="info.comprehensiveData.content">
      <div class="yys-left" v-if="info.comprehensiveData.coachDetail">
        <img
          class="l-img"
          :src="
            info.comprehensiveData.coachDetail.c_img +
            '?x-oss-process=image/resize,m_lfit,h_200,w_200'
          "
          alt=""
        />
        <div class="l-name">{{
          info.comprehensiveData.coachDetail.c_name
        }}</div>
      </div>
      <div class="yys-right">
        {{ info.comprehensiveData.content }}
      </div>
    </div>
    <!-- 减脂成绩 -->
    <div class="sum-panel">
      <!-- 标题背景 -->
      <img
        class="p-top-bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-jzcj"
        alt=""
      />
      <!-- 浮动背景 -->
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-ibg-1?v=1"
        alt=""
        class="p-float-bg"
      />
      <div class="sum-panel-jzcj">
        <template
          v-if="
            !info.comprehensiveData.fatReduction.begin_waist ||
            !info.comprehensiveData.fatReduction.begin_weight ||
            info.comprehensiveData.clockList.physicalNum == 0
          "
        >
          <div class="p-nodata">
            <div class="p-no-title">本周未进行任何体测打卡</div>
            <div class="p-no-text"
              >宝贝是想悄悄变瘦惊艳所有人吗？
              <br />
              上传体测更有助于老师为你分析进度哦
            </div>
          </div>
        </template>
        <template v-else>
          <div class="j-top">
            <!-- 人物形象 -->
            <div class="t-left">
              <img :src="curPerImg" alt="" />
            </div>
            <!-- 纬度数据 -->
            <div class="t-right">
              <div class="r-rank">
                <div class="r-item">
                  <div class="r-title">体重变化(斤)</div>
                  <div class="r-num">{{
                    info.comprehensiveData.fatReduction.weight_diff == '-'
                      ? info.comprehensiveData.fatReduction.weight_diff
                      : (
                          info.comprehensiveData.fatReduction.weight_diff * 2
                        ).toFixed(1)
                  }}</div>
                  <div
                    class="r-no"
                    v-if="info.comprehensiveData.fatReduction.weight_rank"
                    >（排名NO.{{
                      info.comprehensiveData.fatReduction.weight_rank
                    }}）</div
                  >
                </div>
                <div class="r-item">
                  <div class="r-title">腰围变化(厘米)</div>
                  <div class="r-num">{{
                    info.comprehensiveData.fatReduction.waist_diff
                  }}</div>
                  <div
                    class="r-no"
                    v-if="info.comprehensiveData.fatReduction.waist_rank"
                    >（排名NO.{{
                      info.comprehensiveData.fatReduction.waist_rank
                    }}）</div
                  >
                </div>
              </div>
              <div class="r-line" v-if="waistChange && weightChange">
                <img
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-line-bg"
                  class="l-bg"
                  alt=""
                />
                <!-- 只有开始 显示点 -->
                <div class="l-waist-dot" v-if="waistChange == 'desc'"></div>
                <!-- 腰围 曲线-->
                <img
                  v-else
                  :src="`https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-waist-${waistChange}`"
                  class="l-waist-img"
                  :class="`l-waist-img-${waistChange}`"
                  alt=""
                />
                <div
                  class="l-text l-waist-b"
                  :class="`l-waist-b-${waistChange}`"
                  >{{ lineData.waistBefore }}cm</div
                >
                <div
                  class="l-text l-waist-n"
                  v-if="lineData.waistNow"
                  :class="`l-waist-n-${waistChange}`"
                  >{{ lineData.waistNow }}cm</div
                >
                <!-- 体重 -->
                <!-- 只有开始 显示点 -->
                <div class="l-weight-dot" v-if="weightChange == 'desc'"></div>
                <img
                  v-else
                  :src="`https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-weight-${weightChange}`"
                  class="l-weight-img"
                  :class="`l-weight-img-${weightChange}`"
                  alt=""
                />
                <div
                  class="l-text l-weight-b"
                  :class="`l-weight-b-${weightChange}`"
                  >{{ lineData.weightBefore }}kg</div
                >
                <div
                  class="l-text l-weight-n"
                  :class="`l-weight-n-${weightChange}`"
                  v-if="lineData.weightNow"
                  >{{ lineData.weightNow }}kg</div
                >
                <!-- 日期 -->
                <div class="l-date-start">入营</div>
                <div class="l-date-end">{{ eDate }}</div>
              </div>
            </div>
          </div>
          <!-- 体测打卡记录 -->
          <div class="j-list">
            <div class="l-title">
              <img
                class="t-left"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-left"
                alt=""
              />
              体测打卡记录
              <img
                class="t-right"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-right"
                alt=""
              />
            </div>
            <div class="l-clock">
              <div class="l-region">
                <div
                  class="l-item"
                  v-for="(item, index) in info.comprehensiveData.clockRecord"
                  :key="index"
                >
                  <img
                    class="i-img"
                    :src="
                      item.content[0] +
                      '?x-oss-process=image/resize,m_lfit,h_200,w_200'
                    "
                    alt=""
                  />
                  <!-- 日期 -->
                  <div class="i-date">{{
                    item.curDate.slice(5, 11).replace(/-/, '/')
                  }}</div>
                  <!-- 数据 -->
                  <div class="i-data"
                    >体重：{{ item.weight }}kg<br />腰围：{{
                      item.waist
                    }}cm</div
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 饮食回顾 -->
    <div class="sum-panel sum-panel-yshg">
      <img
        class="p-top-bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-yshg"
        alt=""
      />
      <template v-if="!info.comprehensiveData.clockList.dietNum">
        <div class="p-nodata">
          <div class="p-no-title">本周未进行任何饮食打卡</div>
          <div class="p-no-text"
            >宝贝悄悄吃了什么好吃的呢？<br />
            下一周要记得上传哦
          </div>
        </div>
      </template>
      <template v-else>
        <div class="ys-all">
          本周综合得分
          <span>{{ info.dietReview.allScore }}</span>
        </div>
        <sum-radar-chart :info="info.dietReview"></sum-radar-chart>
        <!-- 餐卡记录 -->
        <div
          class="ys-meal-title"
          v-if="
            info.dietReview.fullMark.length ||
            info.dietReview.deductPoint.length
          "
        >
          <img
            class="t-left"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-left"
            alt=""
          />
          餐卡记录
          <img
            class="t-right"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-right"
            alt=""
          />
        </div>
        <!-- 餐卡内容 -->
        <sum-meal-card :info="info.dietReview"></sum-meal-card>
      </template>
    </div>
    <!-- 运动打卡 -->
    <div class="sum-panel sum-panel-jzcj sum-panel-yshg sum-panel-yddk">
      <img
        class="p-top-bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-ydjl"
        alt=""
      />
      <template
        v-if="
          !info.comprehensiveData.motionRecord ||
          info.comprehensiveData.motionRecord.length == 0
        "
      >
        <div class="p-nodata">
          <div class="p-no-title">本周未进行任何运动打卡</div>
          <div class="p-no-text">宝贝本周稳坐如山！没有任何运动 </div>
        </div>
      </template>
      <template v-else>
        <div class="ys-all">
          本周运动次数 <span>{{ info.comprehensiveData.motionNum }}</span>
        </div>
        <!-- 体测打卡记录 -->
        <div class="j-list">
          <div class="l-title">
            <img
              class="t-left"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-left"
              alt=""
            />
            运动打卡记录
            <img
              class="t-right"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-title-right"
              alt=""
            />
          </div>
          <div class="l-clock">
            <div class="l-region">
              <div
                class="l-item"
                v-for="(item, index) in info.comprehensiveData.motionRecord"
                :key="index"
              >
                <img
                  class="i-img"
                  :src="
                    item.url + '?x-oss-process=image/resize,m_lfit,h_200,w_200'
                  "
                  alt=""
                />
                <!-- 日期 -->
                <div class="i-date">{{ item.date.slice(5, 11) }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- logo -->
    <img
      class="sum-logo auto-exp-component"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-8-25-today-eatting-logo"
      alt=""
    />
    <!-- 海报区域 -->
    <sum-poster
      :info="info"
      v-if="showPoster"
      @close="showPoster = false"
    ></sum-poster>
  </div>
  <vLoading v-else></vLoading>
</template>

<script>
import SumPieChart from './ponents/sum-pie-chart'
import SumRadarChart from './ponents/sum-radar-chart'
import SumMealCard from './ponents/sum-meal-card'
import SumPoster from './ponents/sum-poster'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts'
export default {
  name: 'week-summary',

  components: { SumPieChart, SumRadarChart, SumMealCard, SumPoster },

  props: {},

  data() {
    return {
      showPoster: false,
      id: this.$route.query.id,
      echarts: echarts,
      info: null,
      lineData: {},
      pie: null,
      mealInfo: {}
    }
  },

  computed: {
    curPerImg() {
      if (this.info && this.info.userResult.gender === 2) {
        return 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-p-nv'
      }
      if (this.info && this.info.userResult.gender === 1) {
        return 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-p-nan'
      }
      return 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-p-unknown'
    },
    waistChange() {
      if (this.lineData) {
        if (this.lineData.waistBefore && !this.lineData.waistNow) return 'desc'
        if (this.lineData.waistBefore > this.lineData.waistNow) return 'down'
        if (this.lineData.waistBefore < this.lineData.waistNow) return 'up'
        if (this.lineData.waistBefore * 1 === this.lineData.waistNow * 1)
          return 'unc'
      }
      return ''
    },
    weightChange() {
      if (this.lineData) {
        if (this.lineData.weightBefore && !this.lineData.weightNow)
          return 'desc'
        if (this.lineData.weightBefore > this.lineData.weightNow) return 'down'
        if (this.lineData.weightBefore < this.lineData.weightNow) return 'up'
        if (this.lineData.weightBefore * 1 === this.lineData.weightNow * 1)
          return 'unc'
      }
      return ''
    },
    sDate() {
      if (this.info) {
        return this.info.userResult.s_date
          .split('')
          .slice(-5)
          .join('')
          .replace(/-/, '/')
      }
      return ''
    },
    eDate() {
      if (this.info) {
        return this.info.userResult.e_date
          .split('')
          .slice(-5)
          .join('')
          .replace(/-/, '/')
      }
      return ''
    }
  },

  watch: {},

  created() {
    this.getInfo()
    this.$buryPoint('WKSUM_SHOW')
    this.autoBuryPoint()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 友盟自动曝光埋点
    autoBuryPoint() {
      const { aplus_queue } = window
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: [
          'aplus-auto-exp',
          [
            {
              // 需要曝光的元素class
              cssSelector: '.auto-exp-component',
              // 如果页面模块是元素内滚动（某个区块内有滚动条）则需要增加positionSelector辅助定位曝光元素
              positionSelector: '',
              logkey: 'WKSUM_SHOW_FINISH', // 事件管理中的事件id
              props: [] // 你要曝光的元素身上自定义属性
            }
          ]
        ]
      })
    },
    // 点击分享
    handleShare() {
      this.showPoster = true
      this.$buryPoint('WKSUM_SHARE_CLICK')
    },
    // 点击成就
    handleAchi() {
      this.$toast(this.info.comprehensiveData.achievementName.explain)
    },
    // 格式化打卡数据信息
    formatClockData(info) {
      return JSON.parse(info)
    },
    getInfo() {
      // /member/CampWeekly/getWeeklyDetail
      this.$http
        .getApp('member/CampWeekly/getWeeklyDetail', { id: this.id })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info = res.data
            this.pie = {
              diet: {
                done: this.info.comprehensiveData.clockList.dietNum,
                all: this.info.comprehensiveData.clockList.dietTotal,
                title: '饮食(次数)'
              },
              test: {
                done: this.info.comprehensiveData.clockList.physicalNum,
                all: this.info.comprehensiveData.clockList.physicalTotal,
                title: '体测(次数)'
              },
              sport: {
                done: this.info.comprehensiveData.motionNum,
                all: '',
                title: '运动(次数)'
              }
            }
            // 编号曲线数据
            this.lineData = {
              waistBefore:
                +this.info.comprehensiveData.fatReduction.begin_waist || 0,
              waistNow:
                +this.info.comprehensiveData.fatReduction.end_waist || 0,
              weightBefore:
                +this.info.comprehensiveData.fatReduction.begin_weight || 0,
              weightNow:
                +this.info.comprehensiveData.fatReduction.end_weight || 0
            }
            // 设置标题
            document.title = `${this.sDate}-${this.eDate}`
            this.readWeekSummary()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    readWeekSummary() {
      if (!this.$betterwe.isApp()) {
        return
      }
      this.$http.postApp('member/CampWeekly/isRead', { weekly_id: this.id })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.week-summary {
  width: 100vw;
  min-height: 100vh;
  background: #cce9ff;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include paddingBottom(30px);

  .sum-float-bg {
    position: absolute;
    z-index: -1;
    width: 136px;
    right: 0px;
    top: 654px;
  }

  .sum-float-bg-2 {
    position: absolute;
    z-index: -1;
    width: 123px;
    left: 0px;
    top: 1300px;
  }

  .sum-float-bg-3 {
    position: absolute;
    z-index: -1;
    width: 103px;
    left: 0px;
    top: 2260px;
  }

  .sum-float-bg-4 {
    position: absolute;
    z-index: -1;
    width: 85px;
    right: 0px;
    bottom: 0px;
  }

  .sum-top-bg {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .logo {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 13px;
    padding-left: 20px;
    box-sizing: border-box;

    .logo-image {
      height: 10px;
    }

    .desc {
      font-size: 9px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #4d4d4d;
      line-height: 12px;
      letter-spacing: 2px;
      padding: 0px 7px;
      margin-left: 7px;
      border-left: 1px solid rgba(151, 151, 151, 0.6);
    }
  }

  .sum-info {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    padding-left: 20px;
    display: flex;

    .i-left {
      display: flex;
      align-items: center;
      justify-content: center;

      .l-img {
        width: 54px;
        height: 54px;
        border-radius: 12px;
        object-fit: cover;
      }

      .l-desc {
        margin-left: 5px;
      }

      .d-name {
        margin-left: 4px;
        font-size: 18px;
        font-weight: 600;
      }

      .d-title {
        margin-left: 4px;
        font-size: 12px;
        margin-top: 4px;
        color: rgba($color: #000000, $alpha: 0.5);
      }
    }

    .i-right {
      width: 72px;
      height: 33px;
      margin-left: auto;
    }
  }

  .sum-panel {
    width: 335px;
    box-sizing: border-box;
    // background: #ffffff;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    backdrop-filter: blur(12px);
    padding: 15px 0;
    margin-top: 16px;
    position: relative;
    z-index: 1;

    .p-float-bg {
      position: absolute;
      z-index: -1;
      width: 136px;
      right: -20px;
      top: -10px;
    }

    .p-nodata {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: rgba($color: #000000, $alpha: 0.5);
      margin: 15px auto;
      text-align: center;

      .p-no-title {
        font-size: 16px;
        font-weight: 800;
        line-height: 22px;
      }

      .p-no-text {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 8px;
      }
    }

    .p-achi {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;

      .achi-left {
        .l-title {
          font-size: 16px;
          font-weight: 500;
          display: flex;
          align-items: center;

          .l-icon {
            color: rgba($color: #000000, $alpha: 0.3);
            margin-left: 6px;
          }
        }

        .l-img {
          width: 128px;
          margin-top: 6px;
        }
      }

      .achi-right {
        width: 112px;
        position: absolute;
        right: 16px;
        top: -10px;
      }
    }

    .p-desc {
      width: 100%;
      box-sizing: border-box;
      padding: 0 20px;
      padding-right: 10px;
      background: linear-gradient(2deg, #ffffff 0%, #f6f8ff 100%);

      .d-top {
        width: 100%;
        box-sizing: border-box;
        margin-top: 22px;
        padding-top: 12px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba($color: #6236ff, $alpha: 0.08);

        .t-title {
          font-size: 16px;
          font-weight: 500;
        }

        .t-cent-no {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba($color: #000000, $alpha: 0.5);
        }

        .t-cent {
          width: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 20px;

          .c-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .i-title {
              font-size: 12px;
              font-weight: 400;
            }

            .i-num {
              font-family: 'DINC';
              font-size: 30px;
              margin-top: 6px;

              .iconfont {
                color: #f08cc6;
                font-size: 10px;
              }
            }
          }
        }
      }
    }

    .p-top-bg {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      top: -14px;
      left: 0;
      z-index: 1;
    }
  }

  .sum-panel-yys {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);

    .yys-left {
      display: flex;
      flex-direction: column;
      align-items: center;

      .l-img {
        width: 55px;
        height: 55px;
        object-fit: cover;
        border-radius: 16px;
      }

      .l-name {
        font-size: 12px;
        font-weight: 500;
        margin-top: 10px;
      }
    }

    .yys-right {
      flex: 1;
      margin-left: 20px;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      color: rgba($color: #000000, $alpha: 0.7);
    }
  }

  .sum-panel-jzcj {
    padding: 46px 10px;
    padding-bottom: 18px;
    background: #f4faff;

    .j-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .t-left {
        img {
          width: 110px;
        }
      }

      .t-right {
        .r-rank {
          display: flex;
          // align-items: center;
          justify-content: center;

          .r-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            & + .r-item {
              margin-left: 5px;
            }

            .r-title {
              font-size: 12px;
              color: rgba($color: #000000, $alpha: 0.8);
            }

            .r-num {
              font-family: 'DINC';
              font-size: 24px;
              margin-top: 4px;
            }

            .r-no {
              font-size: 12px;
              color: rgba($color: #000000, $alpha: 0.5);
            }
          }
        }

        .r-line {
          position: relative;
          margin-top: 26px;

          .l-bg {
            width: 187px;
          }

          .l-waist-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #6236ff;
            position: absolute;
            left: 18px;
            top: 60px;
          }

          .l-weight-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #ff80e0;
            position: absolute;
            left: 18px;
            top: 74px;
          }

          .l-waist-img,
          .l-weight-img {
            width: 160px;
            position: absolute;
            left: 14px;
            top: 60px;
          }

          // 腰围下降
          .l-waist-img {
            top: 60px;
          }

          // 腰围升高
          .l-waist-img-down {
            top: 60px;
          }

          // 腰围不变
          .l-waist-img-unc {
            top: 112px;
          }

          // 体重下降
          .l-weight-img {
            top: 75px;
          }

          // 体重上升
          .l-weight-img-up {
            top: 75px;
          }

          // 体重不变
          .l-weight-img-unc {
            top: 127px;
          }

          .l-text {
            position: absolute;
            font-size: 10px;
            font-weight: 600;
            color: rgba($color: #000000, $alpha: 0.5);
          }

          .l-waist-b {
            left: 14px;
            top: 40px;
          }

          .l-waist-b-up {
            top: 103px;
          }

          .l-waist-b-unc {
            top: 98px;
          }

          .l-waist-n {
            top: 100px;
            right: 7px;
            color: #6b24ff;
          }

          .l-waist-n-up {
            top: 46px;
          }

          .l-waist-n-unc {
            top: 98px;
          }

          .l-weight-b {
            left: 14px;
            top: 82px;
          }

          .l-weight-b-up {
            top: 144px;
          }

          .l-weight-b-unc {
            top: 134px;
          }

          .l-weight-n {
            top: 143px;
            right: 7px;
            color: #ff80e0;
          }

          .l-weight-n-up {
            top: 82px;
          }

          .l-weight-n-unc {
            top: 134px;
          }

          .l-date-start,
          .l-date-end {
            position: absolute;
            bottom: 10px;
            left: 15px;
            font-size: 10px;
            font-weight: 400;
            color: rgba($color: #000000, $alpha: 0.5);
          }

          .l-date-end {
            left: auto;
            right: 15px;
          }
        }
      }
    }

    .j-list {
      width: 100%;
      box-sizing: border-box;
      margin-top: 40px;

      .l-title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;

        img {
          width: 72px;
          margin: 0 10px;
        }
      }

      .l-clock {
        width: 100%;
        box-sizing: border-box;
        overflow-x: auto;

        .l-region {
          width: fit-content;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          margin-top: 15px;

          .l-item {
            position: relative;
            margin-right: 5px;
            width: 90px;
            height: 90px;
            border-radius: 6px;
            box-sizing: border-box;
            overflow: hidden;

            .i-img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .i-date {
              width: 53px;
              height: 21px;
              background: #ede7ff;
              border-radius: 6px 0px 6px 0px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              font-weight: 600;
              color: rgba($color: #6236ff, $alpha: 0.6);
              position: absolute;
              top: 0;
              left: 0;
            }

            .i-data {
              position: absolute;
              font-size: 9px;
              line-height: 14px;
              font-weight: 400;
              color: rgba($color: #fff, $alpha: 0.8);
              left: 5px;
              bottom: 7px;
            }
          }
        }
      }
    }
  }

  .sum-panel-yshg {
    padding: 64px 12px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);

    .ys-all {
      width: 221px;
      height: 48px;
      background: rgba($color: #6236ff, $alpha: 0.1);
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 500;

      span {
        font-size: 30px;
        font-family: 'DINC';
        margin-left: 15px;
        margin-top: 2px;
      }
    }

    .ys-meal-title {
      width: 100%;
      box-sizing: border-box;
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;

      img {
        width: 72px;
        margin: 0 10px;
      }
    }
  }

  .sum-panel-yddk {
    .j-list {
      margin-top: 20px;
    }
  }

  .sum-logo {
    margin-top: 30px;
    width: 100px;
  }
}
</style>
